import leftPad from './leftPad';

export default function formatAMPM(date) {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  return `${hours % 12 || 12}:${leftPad(minutes, 0, 2)}${ampm}`; // the hour '0' should be '12'
}



// WEBPACK FOOTER //
// ./shared/lib/prettyTime.js